import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import LuxPlusLogo from 'luxPlus/components/Logos/LuxPlusLogo'

const StyledLabelText = styled.span`
  color: ${props => props.theme.palette.neutral.surface.staticWhite};
`

function LuxPlusMonthTakeoverCampaignTagLabel() {
  return <StyledLabelText>
    <FormattedMessage
      id="u3xBThg0mRi7RqaXljHZ"
      defaultMessage="{logo} Member Event"
      description="LuxPlus+ Month campaign tag label shown on offer tiles"
      values={{ logo: <LuxPlusLogo colour="inherit" height={10} inline /> }}
    />
  </StyledLabelText>
}

export default LuxPlusMonthTakeoverCampaignTagLabel
